<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<div style="page-break-after:always"></div><p class="CHAPTER1" id="_idParaDest-1"><a id="_idTextAnchor000"></a>Dedication</p>
<p class="Perfect-Center"><span class="italics _idGenCharOverride-1">For Stephanie and Max, my Sea and Sky.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0003.vue?144ecac8